import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { useI18n as j } from "next-localization";
import { c as f } from "./clsx.OuTLNxxd.js";
import { S as u } from "./index.BhPhnmkE.js";
import { NeuSelect as D } from "@hcahealthcaredpx/neutron-react";
import { u as H } from "./header.context.gmG2mr37.js";
import { L as M } from "./link-button.z9udOW1b.js";
import { P } from "./PageCount.BTdUknYR.js";
const T = ({
  contentType: b,
  contentTypeFacetGroup: e,
  count: N,
  end: v,
  displaySize: S,
  isLoading: i,
  keyword: x,
  onSortChange: C,
  sort: g = "score:desc",
  sortOptions: d,
  start: p,
  hideTitle: w = !1,
  contentTitleClassName: W,
  showErWaitTimes: R = !1,
  titleOverride: h,
  useSmallLayout: c = !1
}) => {
  const { t: m } = j(), t = e == null ? void 0 : e.facets, s = d == null ? void 0 : d.map((l) => ({
    value: l.value,
    label: l.label
  })), n = t == null ? void 0 : t.find((l) => l.value === b), $ = (n == null ? void 0 : n.text) ?? (e == null ? void 0 : e.groupAnyTitle), k = Number(S) || 10, { openERWaitTimeModal: E, erWaitTimeStampWithDate: r } = H();
  return /* @__PURE__ */ o("div", { className: "row no-gutters pt-lg-0 pt-sm-3 pb-0 pb-sm-1", children: [
    /* @__PURE__ */ o("div", { className: f(!c && "col-lg-9", W), children: [
      !w && /* @__PURE__ */ a("p", { className: "neu-display-4 fw-bold mb-2", children: i ? /* @__PURE__ */ a(u, { width: 300 }) : h || m("Search.Content.Title", { contentType: $, keyword: x }) }),
      /* @__PURE__ */ a(
        P,
        {
          className: "pt-0 pb-sm-2 pb-lg-0",
          displaySize: k,
          count: N,
          end: v,
          isLoading: i,
          resultDisplayName: `${m("Common.Results")}`,
          start: p
        }
      )
    ] }),
    s ? /* @__PURE__ */ a("div", { className: f(!c && "col-lg-3"), children: /* @__PURE__ */ a(
      D,
      {
        disabled: i,
        items: s,
        label: `${m("Search.Sort")}`,
        name: `${m("Search.Sort")}`,
        value: s == null ? void 0 : s.find((l) => l.value === g),
        onNeuChange: (l) => {
          C(l.value);
        }
      }
    ) }) : null,
    R ? i ? /* @__PURE__ */ a(u, { width: 300 }) : /* @__PURE__ */ o("div", { className: "pt-2", children: [
      /* @__PURE__ */ a(
        M,
        {
          className: "px-0",
          onClick: () => {
            E();
          },
          children: m("Header.ERWaitTimes.ModalTitle")
        }
      ),
      r ? /* @__PURE__ */ a(
        "time",
        {
          dateTime: r,
          "aria-label": `ER wait time updated at ${r}`,
          children: r
        }
      ) : null
    ] }) : null
  ] });
};
export {
  T as C
};
